export default "__VITE_ASSET__GVEdtUDT__";